var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useState, useRef, useEffect } from 'react';
import t from 'prop-types';
import useInput from '../../util/use-input';
import VinculoFlotante from './vinculo-flotante'; // import EditorTexto from '../editor/components/editor-texto'

function validarUrl(url) {
  var _url$split = url.split('://'),
      pre = _url$split[0],
      resto = _url$split.slice(1);

  if (resto === '') {
    return '';
  }

  if (pre === 'http' || pre === 'https') {
    return url;
  }

  return 'http://' + url;
}

function VinculoEditable(_ref) {
  var texto = _ref.texto,
      offset = _ref.offset,
      tamFuenteBase = _ref.tamFuenteBase,
      activo = _ref.activo,
      minX = _ref.minX,
      maxX = _ref.maxX,
      config = _ref.config,
      onActualizar = _ref.onActualizar;

  var _useState = useState(false),
      modoEdicion = _useState[0],
      setModoEdicion = _useState[1];

  var _useState2 = useState(0),
      ajustarALaDerecha = _useState2[0],
      setAjustarALaDerecha = _useState2[1];

  var _useInput = useInput(texto.textoHtml),
      valorTexto = _useInput.valor,
      bindTexto = _useInput.bind;

  var _useInput2 = useInput(texto.url, validarUrl),
      valorUrl = _useInput2.valor,
      bindUrl = _useInput2.bind;

  var cajaEditorVinculoRef = useRef(null);
  useEffect(function () {
    var cajaEditorVinculo = cajaEditorVinculoRef.current;

    if (cajaEditorVinculo === null || ajustarALaDerecha > 0) {
      return;
    }

    var rootRect = cajaEditorVinculo.getBoundingClientRect();
    var parentRect = cajaEditorVinculo.parentNode.getBoundingClientRect();
    var ajuste = 100 * Math.max(rootRect.right - parentRect.right, 0) / parentRect.width;

    if (ajuste > 0 && ajuste !== ajustarALaDerecha) {
      setAjustarALaDerecha(ajuste);
    }
  }, [modoEdicion, ajustarALaDerecha, valorTexto, valorUrl, cajaEditorVinculoRef]);
  var textoEliminar = config.textoEliminar,
      textoCerrar = config.textoCerrar,
      textoTitulo = config.textoTitulo,
      textoIr = config.textoIr,
      textoURL = config.textoURL;

  function handleActivarEdicion() {
    setModoEdicion(true);
  }

  function handleEliminar() {
    onActualizar && onActualizar(texto.id, {
      textoHtml: "",
      url: ""
    });
    setModoEdicion(false);
  }

  function handleGuardarYCerrar() {
    setModoEdicion(false);
    onActualizar && onActualizar(texto.id, {
      textoHtml: valorTexto,
      url: valorUrl
    });
  }

  function handleMover(x, y) {
    onActualizar && onActualizar(texto.id, {
      x: x,
      y: y
    });
  }

  function handleEnlace() {
    var url = valorUrl;

    if (window.parent.electronContext && window.parent.abrirURL) {
      window.parent.abrirURL(url);
    } else if (window.electronContext && window.abrirURL) {
      window.abrirURL(url);
    } else {
      window.open(url, '_blank');
    }
  }

  var x = texto.x,
      y = texto.y,
      textoHtml = texto.textoHtml;

  if (modoEdicion) {
    return React.createElement('div', {
      ref: cajaEditorVinculoRef,
      className: 'cajaEditorVinculo',
      style: {
        position: 'absolute',
        left: x - ajustarALaDerecha + '%',
        top: y + '%',
        pointerEvents: "auto"
      }
    }, React.createElement('div', {
      className: 'botonera'
    }, React.createElement('div', {
      className: 'botonEditorVinculo eliminarVinculo',
      onClick: handleEliminar
    }, textoEliminar), ' ', React.createElement('div', {
      className: 'botonEditorVinculo cerrarVinculo',
      onClick: handleGuardarYCerrar
    }, textoCerrar)), React.createElement('label', null, textoTitulo, React.createElement('input', bindTexto)), React.createElement('div', {
      className: 'botonEditorVinculo irVinculo',
      onClick: handleEnlace,
      rel: 'noopener noreferrer'
    }, textoIr), React.createElement('label', null, textoURL, React.createElement('input', _extends({
      className: 'direccion'
    }, bindUrl)))); // return <EditorTexto 
    //     offset={offset} tamFuenteBase={tamFuenteBase} 
    //     x={ x } y={ y } textoHtml={ textoHtml }
    //     onModificar={ handleModificar }
    //     onCancelar={ handleCancelarEdicion }
    // />        
  }

  return React.createElement(VinculoFlotante, {
    activo: activo,
    x: x,
    y: y,
    minX: minX,
    maxX: maxX,
    offset: offset,
    tamFuenteBase: tamFuenteBase,
    texto: textoHtml,
    onActivarEdicion: handleActivarEdicion,
    onMover: handleMover
  });
}

VinculoEditable.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.shape({
    id: t.string.isRequired,
    x: t.number.isRequired,
    y: t.number.isRequired,
    textoHtml: t.string.isRequired
  }).isRequired,

  /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  offset: t.shape({
    x: t.number.isRequired,
    y: t.number.isRequired
  }),

  /** tamaño 'normal' de la fuente en pixels. 1em será tratado como de este tamaño. */
  tamFuenteBase: t.number,

  /** si activo === false, el texto no podra moverse ni modificarse **/
  activo: t.bool,
  minX: t.number,
  maxX: t.number,
  config: t.object.isRequired,
  // textoEliminar: t.string, 
  // textoCerrar: t.string, 
  // textoTitulo: t.string, 
  // textoIr: t.string, 
  // textoURL: t.string,

  /** 
   * Evento que lanza el componente para informar de los nuevos valores del texto
   * Debe ser una fución con la forma: (textoId, valores) => {...} 
   * 
   * */
  onActualizar: t.func.isRequired
} : {};
export default VinculoEditable;